import { CircularProgress } from "@mui/material";
import TanstackTable from "components/elements/advance-table/TanstackTable";
import SmallLoader from "components/loader/SmallLoader";
import React from "react";

const LiveClasses = ({ liveClasses, columns, isDataLoading }) => {
  return (
    <>
      {isDataLoading ? (
        <SmallLoader />
      ) : (
        <>
          <TanstackTable
            data={liveClasses}
            columns={columns}
            pagination={true}
          />
        </>
      )}
    </>
  );
};

export default LiveClasses;
